export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const CLEAR_ALL_ALERTS = "CLEAR_ALL_ALERTS";
